export const fiscal = ["C03", "C07", "C08"];
